var _defs, _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "group",
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#495057}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1063",
    transform: "translate(15.566 9.718)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1062"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2422",
    d: "M400.041 273.32h-1.547a4.5 4.5 0 0 1 .244 1.467v6.2a1.929 1.929 0 0 1-.1.613h2.562a1.789 1.789 0 0 0 1.732-1.838v-3.381a2.982 2.982 0 0 0-2.891-3.061z",
    className: "cls-1",
    transform: "translate(-398.494 -273.32)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1065",
    transform: "translate(0 9.718)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1064"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2423",
    d: "M4.19 274.788a4.5 4.5 0 0 1 .244-1.467H2.887A2.982 2.982 0 0 0 0 276.384v3.381a1.789 1.789 0 0 0 1.732 1.835h2.557a1.931 1.931 0 0 1-.1-.613z",
    className: "cls-1",
    transform: "translate(0 -273.321)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1067",
    transform: "translate(5.345 8.122)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1066"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2424",
    d: "M143.252 234.815h-3.536a2.982 2.982 0 0 0-2.887 3.063v6.2a.6.6 0 0 0 .577.613h8.155a.6.6 0 0 0 .577-.613v-6.2a2.982 2.982 0 0 0-2.886-3.063z",
    className: "cls-1",
    transform: "translate(-136.829 -234.815)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1069",
    transform: "translate(6.528)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1068"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2425",
    d: "M170.586 38.84a3.587 3.587 0 0 0-3.472 3.684 3.728 3.728 0 0 0 1.775 3.213 3.293 3.293 0 0 0 3.394 0 3.728 3.728 0 0 0 1.775-3.213 3.587 3.587 0 0 0-3.472-3.684z",
    className: "cls-1",
    transform: "translate(-167.114 -38.84)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1071",
    transform: "translate(1.306 3.434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1070"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2426",
    d: "M36.04 121.689a2.76 2.76 0 0 0 0 5.51 2.455 2.455 0 0 0 1.023-.223 2.679 2.679 0 0 0 1.268-1.238 2.871 2.871 0 0 0 .305-1.294 2.682 2.682 0 0 0-2.596-2.755z",
    className: "cls-1",
    transform: "translate(-33.443 -121.689)"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1073",
    transform: "translate(13.5 3.434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1072"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2427",
    d: "M348.2 121.689a2.682 2.682 0 0 0-2.6 2.755 2.871 2.871 0 0 0 .305 1.294 2.678 2.678 0 0 0 1.268 1.238 2.455 2.455 0 0 0 1.023.223 2.76 2.76 0 0 0 0-5.51z",
    className: "cls-1",
    transform: "translate(-345.607 -121.689)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGroup);
export default __webpack_public_path__ + "static/media/icon-group.4616fc7a7ceeb77a319014925a219be0.svg";
export { ForwardRef as ReactComponent };